import { CityDistrict, InsertCityMultipleDistrict, UpsertCityDistrict } from '@/models/city-district.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedCityDistricts = async (input: PaginationFilterRequest): Promise<PagedResponseModel<CityDistrict>> => {
  return await getReq(createUrl("a/CityDistrict/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getCityDistrictsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedCityDistricts(model).then(data =>
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })    
  );
};

export const getCityDistrict = async (id: number): Promise<BaseResponseModel<CityDistrict>> => {
  return await getReq(createUrl(`a/CityDistrict/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertCityDistrict = async (input: UpsertCityDistrict): Promise<BaseResponseModel<CityDistrict>> => {
  return await postReq(createUrl("a/CityDistrict/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const insertCityMultipleDistrict = async (input: InsertCityMultipleDistrict): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/CityDistrict/Multiple/Insert"),
    input
  ).then((res: any) => res.data);
};
